import builder from '../builder';
import Lock2 from '../../streamline-icons/bold/lock-2.svg';

export default builder('IconLock2Bold', Lock2);
